/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    className: 'll-mpf',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // Accessibility for back button
      if ( $( '.llgq-quoter-back' ).length > 0 ) {
        $( '.llgq-quoter-back' ).append( '<span class="sr-only">Back</span>' );
      }

      // --- Add Pain Quiz page counter ---
      const quizLabel = document.querySelector( '.ll-mpf__footer p.hdg-1' );
      let pageInfo;
      if ( quizLabel ) {
        pageInfo = document.createElement( 'span' );
        pageInfo.style.marginLeft = '2px';
        quizLabel.appendChild( pageInfo );
      }

      function updatePageInfo( currentPage ) {
        const totalPages = document.querySelectorAll( '.gform_page' ).length;
        if ( pageInfo ) {
          pageInfo.textContent = currentPage + ' of ' + totalPages;
        }
      }

      // Initial page info
      const currentPageInitial = document.querySelector( '.gform_page.current_page' );
      updatePageInfo( currentPageInitial ? currentPageInitial.dataset.pageNumber : 1 );

      // Listen for Gravity Forms page changes
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const pages = document.querySelectorAll( '.gform_page' ).length;

        // Update Pain Quiz page counter
        updatePageInfo( currentPage );

        // Show submit button on last page
        if ( parseInt( currentPage ) === pages ) {
          $( '.ll-mpf-submit' ).removeClass( 'hidden' );
          $( '.ll-submit' ).addClass( 'sr-only' );
          $( '.ll-mpf-submit' ).on( 'click', function( e ) {
            e.preventDefault();
            const submitButton = document.querySelector( '.ll-submit' );
            if ( submitButton && window.gform && window.gform.submission ) {
              window.gform.submission.handleButtonClick( submitButton );
            }
          } );
        } else {
          if ( !$( '.ll-mpf-submit' ).hasClass( 'hidden' ) ) {
            $( '.ll-mpf-submit' ).addClass( 'hidden' );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );
